module.exports = __webpack_public_path__ + "img/44.d64bc821.svg";